/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Chkk API v1.0
 * Chkk API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */

/**
 * ???
 */
export type ClusterStatus = (typeof ClusterStatus)[keyof typeof ClusterStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClusterStatus = {
  active: 'active',
  deactivated: 'deactivated',
} as const;
